import React from "react";
import { Navigate, useParams } from "react-router-dom";
import Home from "../pages/home";
import Page from "@jumbo/shared/Page";
import Login from "app/pages/auth-pages/login/Login";
import ForgotPassword from "app/pages/auth-pages/forgot-password/ForgotPassword";
import Templates from "app/pages/templates/Templates";
import Images from "app/pages/media/images/Images";
import Videos from "app/pages/media/videos/Videos";
import Presentations from "app/pages/presentation/Presentations";
import EditPresentation from "app/pages/presentation/EditPresentation";
import MainModule from "app/pages/presentation/module/MainModule";
import EditBlock from "app/pages/presentation/block/EditBlock";
import Screens from "app/pages/screen/Screens";
import ArticleCategories from "app/pages/article-category/ArticleCategories";
import ScreenPresentations from "app/pages/screen/ScreenPresentations";
import Galleries from "app/pages/media/galleries/Galleries";
import Articles from "app/pages/article/Articles";
import Devices from "app/pages/device/Devices";
import EditGallery from "app/pages/media/galleries/EditGallery";
import Customers from "app/pages/customers/Customers";
import Products from "app/pages/product/Products";
import EditProduct from "app/pages/product/EditProduct";
import ProductCategories from "app/pages/product-category/ProductCategories";
import ProductAttributes from "app/pages/product-attribute/ProductAttributes";
import Menus from "app/pages/menu/Menus";
import EditMenu from "app/pages/menu/EditMenu";
import DailyOffers from "app/pages/daily-offer/DailyOffers";
import EditDailyOffer from "app/pages/daily-offer/EditDailyOffer";
import RemoteControlMenu from "app/pages/menu/RemoteControlMenu";
import RemoteControlOffer from "app/pages/daily-offer/RemoteControlOffer";
import EditDevice from "app/pages/device/EditDevice";
import DSOKDetails from "app/pages/customers/dsok/DSOKDetails";
import DSOKCategories from "app/pages/customers/dsok/dsok-category/DSOKCategories";
import DSOKProducts from "app/pages/customers/dsok/dsok-products/DSOKProducts";
import DSOKProductDetail from "app/pages/customers/dsok/dsok-products/DSOKProductDetail";
import DSOKOrders from "app/pages/customers/dsok/dsok-orders/DSOKOrders";
import DSOKReports from "app/pages/customers/dsok/dsok-reports/DSOKReports";
import PartnerLogin from "app/pages/partner/PartnerLogin";
import DSOKProductAttributes from "app/pages/customers/dsok/dsok-product-attributes/DSOKProductAttributes";
import Admin from "app/pages/partner/Admin";
import AdminDashboardPage from "app/pages/admin/AdminDashboardPage";
import PartnerHome from "app/pages/partner/PartnerHome";
import OrderList from "app/pages/partner/order/Orders";
import OrderDetail from "app/pages/partner/order/OrderDetail";
import InvalidUrl from "app/pages/partner/InvalidUrl";
import EasyPayOrders from "app/pages/customers/easyPay/easyPay-orders/EasyPayOrders";
import CallScreen from "app/pages/customers/easyPay/easyPay-orders/callScreen";
import DSOKReportsOverview from "app/pages/customers/dsok/dsok-reports/ReoprtsOverview";
import SmartkioskDetails from "app/pages/customers/dsok/SmartkioskDetails";
import ClientList from "app/pages/customers/clients/ClientList";
import ClientForm from "app/pages/customers/clients/ClientForm";
import EmployeeForm from "app/pages/customers/clients/EmployeeForm";
import ClientEmployeesList from "app/pages/customers/clients/ClientEmployeesList";
import DsokMenu from "app/pages/dsokMenu/Menus";
import DsokDailyMenuList from "app/pages/dsokDailyMenu/DsokDailyMenuList";
import DsokDailyMenuEdit from "app/pages/dsokDailyMenu/DsokDailyMenuEdit";
import DsokDailyMenuScreenSettings from "app/pages/dsokDailyMenu/DsokDailyMenuScreenSettings";
import MenuManagerList from "app/pages/menuManager/MenuManagerList";
import MenuBoardEdit from "app/pages/menuManager/MenuBoardEdit";
import DsokEditMenu from "app/pages/dsokMenu/EditMenu";
import DsokEditCategory from "app/pages/customers/dsok/dsok-category/EditCategory";
import DSOKPromotions from "app/pages/customers/dsok/dsok-promotions/DSOKPromotions";
import DsokEditPromotion from "app/pages/customers/dsok/dsok-promotions/DsokEditPromotion";
import OrderStatusScreen from "app/pages/customers/dsok/dsok-orders/statusScreen/OrderStatusScreen";
import DailyMenuScreenRouter from "app/pages/DailyMenuScreen/DailyMenuScreenRouter";
import DSOKDispensingOrders from "app/pages/customers/dsok/dsok-orders/dispensing-orders/DSOKDispensingOrders";
import AlbaconSimulator from "app/pages/customers/dsok/albacon-simulator/AlbaconSimulator";
import AddNewCustomer from "app/pages/customers/NewCustomer/AddNewCustomer";
import CreateCustomerPage from "app/pages/customers/dsok/customersNew";
import DSOKCartRules from "app/pages/customers/dsok/dsok-cart-rules/DSOKCartRules";
import EditRule from "app/pages/customers/dsok/dsok-cart-rules/EditRule";
import ClientOrdersList from "app/pages/customers/clients/ClientOrdersList";
import DSOKBindings from "app/pages/customers/dsok/dsok-bindings/DSOKBindings";
import KioskManagement from "app/pages/customers/dsok/kiosk-management/KioskManagement";
import EditBinding from "app/pages/customers/dsok/dsok-bindings/EditBinding";
import Logs from "app/pages/logs/Logs";
import ProductSyncLogs from "app/pages/logs/ProductSyncLogs";
import CreatedOrdersLogsPage from "app/pages/logs/CreatedOrdersLogsPage";
import PriceCalculatorPage from "app/pages/price-calculator/PriceCalculatorPage";
import PriceCalculatorTypeTablePage from "app/pages/price-calculator/PriceCalculatorTypeTablePage";
import PriceCalculatorQuotePage from "app/pages/price-calculator/PriceCalculatorQuotePage";
import Calculations from "app/pages/calculations/Calculations";
import CalculationsProductDetail from "app/pages/calculations/CalculationsProductDetail";
import CalculationsRouteGuard from "app/shared/CalculationsRouteGuard";
import AccessSystemPage from "app/pages/customers/dsok/access-system/AccessSystemPage";
import AccessSystemSettingsPage from "app/pages/customers/dsok/access-system/AccessSystemSettingsPage";
import AccessSystemVouchersPage from "app/pages/customers/dsok/access-system/AccessSystemVouchersPage";
import AccessSystemVoucherFormPage from "app/pages/customers/dsok/access-system/AccessSystemVoucherFormPage";
import AccessSystemZonesPage from "app/pages/customers/dsok/access-system/AccessSystemZonesPage";
import AccessSystemZoneFormPage from "app/pages/customers/dsok/access-system/AccessSystemZoneFormPage";
import DsokPosUsersPage from "app/pages/customers/dsok/pos/DsokPosUsersPage";
import DsokPosWorkspacesPage from "app/pages/customers/dsok/pos/DsokPosWorkspacesPage";
import DsokPosWorkspaceDetailPage from "app/pages/customers/dsok/pos/DsokPosWorkspaceDetailPage";
import DsokPosWorkspaceNewPage from "app/pages/customers/dsok/pos/DsokPosWorkspaceNewPage";
import DSOKUsers from "app/pages/customers/dsok/users/DSOKUsers";
import DSOKUserForm from "app/pages/customers/dsok/users/DSOKUserForm";
import IntegrationServerLogsPage from "app/pages/customers/dsok/integration-server/IntegrationServerLogsPage";
import { dsokCustomerDetailRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerDetailRoute";
import { dsokCustomerSettingsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerSettingsRoute";
import { dsokCustomerUiSettingsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerUiSettingsRoute";
import { dsokCustomerLocationsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerLocationsRoute";
import { dsokCustomerDevicesRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerDevicesRoute";
import { dsokCustomerAppSettingsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerAppSettingsRoute";
import { dsokCustomerColorsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerColorsRoute";
import { dsokCustomerProductsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerProductsRoute";
import { dsokCustomerCartRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerCartRoute";
import { dsokCustomerCategoriesRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerCategoriesRoute";
import { dsokCustomerDynamicComponentsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerDynamicComponentsRoute";
import { dsokCustomerIntegrationsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerIntegrationsRoute";
import { dsokCustomerTranslationsRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerTranslationsRoute";
import { dsokCustomerWorkspacesRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerWorkspacesRoute";
import { dsokCustomerMaintenanceRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerMaintenanceRoute";
import { dsokCustomerBillingRoute } from "app/features/dsokCustomerDetail/routes/DsokCustomerBillingRoute";
import { FAQList, FAQDetail } from "app/modules/faq";
import SystemSettingsPage from "app/pages/dsok/systemSettings/SystemSettingsPage";
import ApiDocsChooserPage from "app/pages/dsok/systemSettings/ApiDocsChooserPage";
import ApiDocsViewerPage from "app/pages/dsok/systemSettings/ApiDocsViewerPage";
import PartnerDocsPublicPage from "app/pages/dsok/partnerDocs/PartnerDocsPublicPage";
import NewCustomerSettingsPage from "app/pages/dsok/systemSettings/NewCustomerSettingsPage";
import NewCustomerColorsPage from "app/pages/dsok/systemSettings/NewCustomerColorsPage";
import NewCustomerTranslationsPage from "app/pages/dsok/systemSettings/NewCustomerTranslationsPage";
import DsokProcessedOrderPage from "app/pages/dsok/processed-order/DsokProcessedOrderPage";
import BillingHistoryPage from "app/pages/billing/BillingHistoryPage";
import BillingInvoicesPage from "app/pages/billing/BillingInvoicesPage";
import BillingSystemSettingsPage from "app/pages/dsok/systemSettings/BillingSystemSettingsPage";

function RedirectDsokCustomerDetailToNewPath() {
  const { customerUrl } = useParams();
  return <Navigate to={`/dsok/customer-detail/${customerUrl}`} replace />;
}

function RedirectPrintersToCustomerDetail() {
  const { customerUrl } = useParams();
  return <Navigate to={`/dsok/customer-detail/${customerUrl}`} replace />;
}

/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
const routesForPublic = [
  {
    // Verejná partnerská API dokumentácia – vlastné zdieľané meno+heslo (mimo systémového loginu).
    path: "/partner-docs",
    element: <Page component={PartnerDocsPublicPage} layout={"solo-page"} />,
  },
  {
    path: "/menu/remote-control/:customerId/:url",
    element: <Page component={RemoteControlMenu} layout={"solo-page"} />,
  },
  {
    path: "/daily-offer/remote-control/:customerId/:url",
    element: <Page component={RemoteControlOffer} layout={"solo-page"} />,
  },
  {
    path: "/easy-pay/call-screen/:customerCode/:locationCode/:env/:languages",
    element: <Page component={CallScreen} layout={"solo-page"} />,
  },
  {
    path: "/easy-pay/call-screen/:customerCode/:locationCode/:env/:languages/:timeInterval",
    element: <Page component={CallScreen} layout={"solo-page"} />,
  },
  {
    path: "/order-status-screen/:customerCode/:locationCode/:env/:languages/:timeInterval/:type",
    element: <Page component={OrderStatusScreen} layout={"solo-page"} />,
  },
  {
    // Operátorská výdajová obrazovka (management stavov objednávok). Otvára sa
    // priamo cez URL bez admin loginu — kľúčom sú parametre v URL, preto je
    // verejná (rovnako ako order-status-screen / call-screen).
    path: "/customer/dsok/dispensing-orders/:customerCode/:locationCode/:env/:customerId",
    element: <Page component={DSOKDispensingOrders} layout={"solo-page"} />,
  },
  {
    // Albacon kiosk test simulator — public solo-page (keyed by customerId in URL). Uses the admin
    // token from localStorage to mint a kiosk token via generateToken, then drives /smartkiosk/*.
    path: "/customer/dsok/albacon-simulator/:customerId",
    element: <Page component={AlbaconSimulator} layout={"solo-page"} />,
  },
  {
    path: "/daily-menu-screen/:customerCode/:locationCode/:orientation",
    element: <Page component={DailyMenuScreenRouter} layout={"solo-page"} />,
  },
  {
    path: "/dsok/processed-order",
    element: <Page component={DsokProcessedOrderPage} layout={"solo-page"} />,
  },
];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  {
    path: "/dsok-customer-detail/:customerUrl",
    element: <RedirectDsokCustomerDetailToNewPath />,
  },
  dsokCustomerSettingsRoute,
  dsokCustomerUiSettingsRoute,
  dsokCustomerLocationsRoute,
  dsokCustomerDevicesRoute,
  dsokCustomerAppSettingsRoute,
  dsokCustomerColorsRoute,
  dsokCustomerProductsRoute,
  dsokCustomerCartRoute,
  dsokCustomerCategoriesRoute,
  dsokCustomerDynamicComponentsRoute,
  dsokCustomerIntegrationsRoute,
  dsokCustomerTranslationsRoute,
  dsokCustomerWorkspacesRoute,
  dsokCustomerMaintenanceRoute,
  dsokCustomerBillingRoute,
  {
    path: "/dsok/customer-detail/:customerUrl/printers",
    element: <RedirectPrintersToCustomerDetail />,
  },
  dsokCustomerDetailRoute,
  {
    path: "/dsok/faq",
    element: <Page component={FAQList} />,
  },
  {
    path: "/dsok/faq/:urlKey",
    element: <Page component={FAQDetail} />,
  },
  {
    path: "/dsok/system-settings",
    element: <Page component={SystemSettingsPage} />,
  },
  {
    path: "/dsok/system-settings/developer/api-docs",
    element: <Page component={ApiDocsChooserPage} />,
  },
  {
    path: "/dsok/system-settings/developer/api-docs/:audience",
    element: <Page component={ApiDocsViewerPage} />,
  },
  {
    path: "/dsok/system-settings/billing",
    element: <Page component={BillingSystemSettingsPage} />,
  },
  {
    path: "/dsok/billing/history",
    element: <Page component={BillingHistoryPage} />,
  },
  {
    path: "/dsok/billing/invoices",
    element: <Page component={BillingInvoicesPage} />,
  },
  {
    path: "/dsok/system-settings/new-customer-settings",
    element: <Page component={NewCustomerSettingsPage} />,
  },
  {
    path: "/dsok/system-settings/new-customer-settings/colors",
    element: <Page component={NewCustomerColorsPage} />,
  },
  {
    path: "/dsok/system-settings/new-customer-settings/translations",
    element: <Page component={NewCustomerTranslationsPage} />,
  },
  {
    path: "/admin/dashboard",
    element: <Page component={AdminDashboardPage} />,
  },
  {
    path: "/",
    element: <Page component={Home} />,
  },
  {
    path: "/price-calculator",
    element: <Page component={PriceCalculatorPage} />,
  },
  {
    path: "/price-calculator/type-table",
    element: <Page component={PriceCalculatorTypeTablePage} />,
  },
  {
    path: "/price-calculator/quote",
    element: <Page component={PriceCalculatorQuotePage} layout={"solo-page"} />,
  },
  {
    path: "/calculations",
    element: (
      <CalculationsRouteGuard>
        <Page component={Calculations} />
      </CalculationsRouteGuard>
    ),
  },
  {
    path: "/calculations/products/:productKey",
    element: (
      <CalculationsRouteGuard>
        <Page component={CalculationsProductDetail} />
      </CalculationsRouteGuard>
    ),
  },
  {
    path: "/templates",
    element: <Page component={Templates} />,
  },
  {
    path: "/presentations/",
    element: <Page component={Presentations} />,
  },
  {
    path: "/screens/",
    element: <Page component={Screens} />,
  },
  {
    path: "/screen/:url",
    element: <Page component={ScreenPresentations} />,
  },
  {
    path: "/presentation/:url",
    element: <Page component={EditPresentation} />,
  },
  {
    path: "/presentation/:url/block/:blockUrl/",
    element: <Page component={EditBlock} />,
  },
  {
    path: "/presentation/:url/block/:blockUrl/module/:moduleUrl",
    element: <Page component={MainModule} />,
  },
  {
    path: "/media/images",
    element: <Page component={Images} />,
  },
  {
    path: "/media/videos",
    element: <Page component={Videos} />,
  },
  {
    path: "/media/galleries",
    element: <Page component={Galleries} />,
  },
  {
    path: "/media/gallery/:url",
    element: <Page component={EditGallery} />,
  },
  {
    path: "/kiosk/articles",
    element: <Page component={Articles} />,
  },
  {
    path: "/kiosk/article-categories",
    element: <Page component={ArticleCategories} />,
  },
  {
    path: "/kiosk/devices",
    element: <Page component={Devices} />,
  },
  {
    path: "/kiosk/device/:url",
    element: <Page component={EditDevice} />,
  },
  {
    path: "/products/",
    element: <Page component={Products} />,
  },
  {
    path: "/product/:url",
    element: <Page component={EditProduct} />,
  },
  {
    path: "/product-categories/",
    element: <Page component={ProductCategories} />,
  },
  {
    path: "/product-attributes/",
    element: <Page component={ProductAttributes} />,
  },
  {
    path: "/daily-offers/",
    element: <Page component={DailyOffers} />,
  },
  {
    path: "/daily-offer/:url",
    element: <Page component={EditDailyOffer} />,
  },
  {
    path: "/menus/",
    element: <Page component={Menus} />,
  },
  {
    path: "/menu/:url",
    element: <Page component={EditMenu} />,
  },
  {
    path: "/customer/dsok",
    element: <Page component={DSOKDetails} />,
  },
  {
    path: "/customer/dsok/categories",
    element: <Page component={DSOKCategories} />,
  },
  {
    path: "/customer/dsok/promotions",
    element: <Page component={DSOKPromotions} />,
  },
  {
    path: "/customer/dsok/categories/:categoryId",
    element: <Page component={DsokEditCategory} />,
  },
  {
    path: "/customer/dsok/promotions/:promotionId",
    element: <Page component={DsokEditPromotion} />,
  },
  {
    path: "/customer/dsok/products",
    element: <Page component={DSOKProducts} />,
  },
  {
    path: "/customer/dsok/products/:productId",
    element: <Page component={DSOKProductDetail} />,
  },
  {
    path: "/customer/dsok/orders",
    element: <Page component={DSOKOrders} />,
  },
  {
    path: "/customer/dsok/product-attributes",
    element: <Page component={DSOKProductAttributes} />,
  },
  {
    path: "/customer/dsok/menu",
    element: <Page component={DsokMenu} />,
  },
  {
    path: "/customer/dsok/daily-menu/new",
    element: <Page component={DsokDailyMenuEdit} />,
  },
  {
    path: "/customer/dsok/daily-menu/screen-settings",
    element: <Page component={DsokDailyMenuScreenSettings} />,
  },
  {
    path: "/customer/dsok/daily-menu/:dailyMenuId",
    element: <Page component={DsokDailyMenuEdit} />,
  },
  {
    path: "/customer/dsok/daily-menu",
    element: <Page component={DsokDailyMenuList} />,
  },
  {
    path: "/customer/dsok/boards/new",
    element: <Page component={MenuBoardEdit} />,
  },
  {
    path: "/customer/dsok/boards/:boardId",
    element: <Page component={MenuBoardEdit} />,
  },
  {
    path: "/customer/dsok/boards",
    element: <Page component={MenuManagerList} />,
  },
  {
    path: "/customer/dsok/menu/:menuId",
    element: <Page component={DsokEditMenu} />,
  },
  {
    path: "/customer/dsok/reports",
    element: <Page component={DSOKReports} />,
  },
  {
    path: "/customer/dsok/shopping-cart-rules",
    element: <Page component={DSOKCartRules} />,
  },
  {
    path: "/customer/dsok/shopping-cart-auto-discounts",
    element: <Page component={DSOKCartRules} />,
  },
  {
    path: "/customer/dsok/access-system",
    element: (
      <Navigate to="/customer/dsok/access-system/tickets-management" replace />
    ),
  },
  {
    path: "/customer/dsok/access-system/tickets-management",
    element: <Page component={AccessSystemPage} />,
  },
  {
    path: "/customer/dsok/access-system/zones-management/new",
    element: <Page component={AccessSystemZoneFormPage} />,
  },
  {
    path: "/customer/dsok/access-system/zones-management/:zoneId",
    element: <Page component={AccessSystemZoneFormPage} />,
  },
  {
    path: "/customer/dsok/access-system/zones-management",
    element: <Page component={AccessSystemZonesPage} />,
  },
  {
    path: "/customer/dsok/access-system/vouchers-management/new",
    element: <Page component={AccessSystemVoucherFormPage} />,
  },
  {
    path: "/customer/dsok/access-system/vouchers-management/:voucherId",
    element: <Page component={AccessSystemVoucherFormPage} />,
  },
  {
    path: "/customer/dsok/access-system/vouchers-management",
    element: <Page component={AccessSystemVouchersPage} />,
  },
  {
    path: "/customer/dsok/access-system/settings",
    element: <Page component={AccessSystemSettingsPage} />,
  },
  {
    path: "/customer/dsok/pos/users",
    element: <Page component={DsokPosUsersPage} />,
  },
  {
    path: "/customer/dsok/pos/workspaces/new",
    element: <Page component={DsokPosWorkspaceNewPage} />,
  },
  {
    path: "/customer/dsok/pos/workspaces/:workspaceUuid",
    element: <Page component={DsokPosWorkspaceDetailPage} />,
  },
  {
    path: "/customer/dsok/pos/workspaces",
    element: <Page component={DsokPosWorkspacesPage} />,
  },
  {
    path: "/customer/dsok/users",
    element: <Page component={DSOKUsers} />,
  },
  {
    path: "/customer/dsok/users/:userId",
    element: <Page component={DSOKUserForm} />,
  },
  {
    path: "/customer/dsok/cart-rules/new",
    element: <Page component={EditRule} />,
  },
  {
    path: "/customer/dsok/cart-rules/new/auto",
    element: <Page component={EditRule} />,
  },
  {
    path: "/customer/dsok/cart-rules/:ruleId",
    element: <Page component={EditRule} />,
  },
  {
    path: "/customer/dsok/reports-overview",
    element: <Page component={DSOKReportsOverview} />,
  },
  {
    path: "/customer/easypay/orders",
    element: <Page component={EasyPayOrders} />,
  },
  {
    path: "/customer/dsok/clients",
    element: <Page component={ClientList} />,
  },
  {
    path: "/customer/dsok/clients/:clientId",
    element: <Page component={ClientForm} />,
  },
  {
    path: "/customer/dsok/clients/:clientId/employees",
    element: <Page component={ClientEmployeesList} />,
  },
  {
    path: "/customer/dsok/clients/:clientId/employees/:employeeId",
    element: <Page component={EmployeeForm} />,
  },
  {
    path: "/customer/dsok/clients/:clientId/orders",
    element: <Page component={ClientOrdersList} />,
  },
  {
    path: "/customer/dsok/new",
    element: <Page component={AddNewCustomer} />,
  },
  {
    path: "/customer/dsok/bindings",
    element: <Page component={DSOKBindings} />,
  },
  {
    path: "/customer/dsok/kiosk-management",
    element: <Page component={KioskManagement} />,
  },
  {
    path: "/customer/dsok/bindings/:bindingId",
    element: <Page component={EditBinding} />,
  },
  {
    path: "/customer/dsok/bindings/new",
    element: <Page component={EditBinding} />,
  },
  {
    path: "/customer/dsok/logs/integration-server-logs",
    element: <Page component={IntegrationServerLogsPage} />,
  },
];

const templateRoutes = [
  {
    path: "/templates",
    element: <Page component={Templates} />,
  },
];

const screenRoutes = [
  {
    path: "/screens/",
    element: <Page component={Screens} />,
  },
  {
    path: "/screen/:url",
    element: <Page component={ScreenPresentations} />,
  },
];

const presentationRoutes = [
  {
    path: "/presentations/",
    element: <Page component={Presentations} />,
  },
  {
    path: "/presentation/:url",
    element: <Page component={EditPresentation} />,
  },
  {
    path: "/presentation/:url/block/:blockUrl/",
    element: <Page component={EditBlock} />,
  },
  {
    path: "/presentation/:url/block/:blockUrl/module/:moduleUrl",
    element: <Page component={MainModule} />,
  },
];

const productRoutes = [
  {
    path: "/products/",
    element: <Page component={Products} />,
  },
  {
    path: "/product/:url",
    element: <Page component={EditProduct} />,
  },
  {
    path: "/product-categories/",
    element: <Page component={ProductCategories} />,
  },
  {
    path: "/product-attributes/",
    element: <Page component={ProductAttributes} />,
  },
  {
    path: "/daily-offers/",
    element: <Page component={DailyOffers} />,
  },
  {
    path: "/daily-offer/:url",
    element: <Page component={EditDailyOffer} />,
  },
  {
    path: "/menus/",
    element: <Page component={Menus} />,
  },
  {
    path: "/menu/:url",
    element: <Page component={EditMenu} />,
  },
];

const kioskRoutes = [
  {
    path: "/kiosk/articles",
    element: <Page component={Articles} />,
  },
  {
    path: "/kiosk/article-categories",
    element: <Page component={ArticleCategories} />,
  },
  {
    path: "/kiosk/devices",
    element: <Page component={Devices} />,
  },
];

const dsokRoutes = [
  {
    path: "/customer/dsok",
    element: <Page component={DSOKDetails} />,
  },
  {
    path: "/customer/dsok/categories",
    element: <Page component={DSOKCategories} />,
  },
  {
    path: "/customer/dsok/products",
    element: <Page component={DSOKProducts} />,
  },
  {
    path: "/customer/dsok/orders",
    element: <Page component={DSOKOrders} />,
  },
  {
    path: "/customer/dsok/dispensing-orders",
    element: <Page component={DSOKDispensingOrders} layout={"solo-page"} />,
  },
  {
    path: "/customer/dsok/product-attributes",
    element: <Page component={DSOKProductAttributes} />,
  },
  {
    path: "/customer/dsok/reports",
    element: <Page component={DSOKReports} />,
  },
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: "/user/login",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/user/forgotPassword",
    element: <Page component={ForgotPassword} layout={"solo-page"} />,
  },
  {
    path: "/:url",
    element: <Page component={InvalidUrl} layout={"solo-page"} />,
  },
  {
    path: "/:url/:url",
    element: <Page component={InvalidUrl} layout={"solo-page"} />,
  },
  {
    path: "/:url/:url/:url",
    element: <Page component={InvalidUrl} layout={"solo-page"} />,
  },
  {
    path: "/manage/partner-login-test",
    element: <Page component={PartnerLogin} layout={"solo-page"} />,
  },
  {
    path: "/manage/dashboard",
    element: <Page component={PartnerHome} />,
  },
  {
    path: "/manage/:url",
    element: <Page component={InvalidUrl} layout={"solo-page"} />,
  },
  {
    path: "/manage/editor",
    element: <Page component={Admin} />,
  },
  {
    path: "/manage/orders/list",
    element: <Page component={OrderList} />,
  },
  {
    path: "/manage/orders/order/:externalOrderId",
    element: <Page component={OrderDetail} />,
  },
  // {
  //   path: "/manage/admin",
  //   element: <Page component={Admin} />,
  // },
  {
    path: "/logs",
    element: <Page component={Logs} />,
  },
  {
    path: "/logs/product-sync",
    element: <Page component={ProductSyncLogs} />,
  },
  {
    path: "/logs/integration-server-logs",
    element: <Page component={IntegrationServerLogsPage} />,
  },
  {
    path: "/logs/created-orders",
    element: <Page component={CreatedOrdersLogsPage} />,
  },
];

/**
 routes only accessible for superadmin
 **/
const routesForSuperAdminOnly = [
  {
    path: "/customers",
    element: <Page component={Customers} />,
  },
  {
    path: "/dsok/customers/new",
    element: <Page component={CreateCustomerPage} />,
  },
  {
    path: "/dsok/customers",
    element: (
      <Page component={(props) => <Customers {...props} dsok={true} />} />
    ),
  },
  {
    path: "/customer/:url/dsok",
    element: <Page component={DSOKDetails} />,
  },
  {
    path: "/customer/:url/smartkiosk",
    element: <Page component={SmartkioskDetails} />,
  },
];

const routes = [
  ...routesForPublic,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
  ...routesForSuperAdminOnly,
  ...dsokRoutes,
];

export {
  routes as default,
  routesForPublic,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
  routesForSuperAdminOnly,
  kioskRoutes,
  screenRoutes,
  templateRoutes,
  presentationRoutes,
  productRoutes,
  dsokRoutes,
};
